<template>
    <el-menu
            :default-active="$route.path"
            background-color="#2c2f35"
            text-color="#fff"
            router
            :default-openeds="['1']"
            class="el-menu-vertical-demo">
        <el-submenu index="1">
            <template slot="title">
                <i class="el-icon-location"></i>
                <span>公众号配置</span>
            </template>
            <el-menu-item :index="setting">菜单配置</el-menu-item>
            <el-menu-item :index="messageReply">消息自动回复</el-menu-item>
        </el-submenu>
    </el-menu>
</template>

<script>
    export default {
        name: "SideMenu",
        data() {
            return {
                setting: "/home/menu/setting",
                messageReply: "/home/menu/messageReply"
            }
        },
        methods: {
            defaultMenu() {
                this.$router.push(this.setting);
            }
        },
        mounted() {
            this.defaultMenu();
        }
    }
</script>

<style scoped>
    /*.el-menu-vertical-demo {*/
    /*height: 100%;*/
    /*}*/

    /*.el-submenu .el-menu-item {*/
    /*min-width: 179px;*/
    /*}*/
    .el-menu {
        border-right: none;
    }
</style>